import { render } from "./Skincare.vue?vue&type=template&id=24e84294&scoped=true"
import script from "./Skincare.vue?vue&type=script&lang=js"
export * from "./Skincare.vue?vue&type=script&lang=js"

import "./Skincare.vue?vue&type=style&index=0&id=24e84294&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e84294"]])

export default __exports__